import * as Telecom from '@servicetitan/telecom-rtcs-client';
import setQueueStatus from './setQueueStatus';
import getQueue from '../../lib/getQueue';
import log from '../../lib/log';
import { refreshQueueOnCacheMiss } from '../../lib/refreshQueue';
import featureFlagModule, { FeatureFlagKeys } from '@modules/FeatureFlagModule';
import { enqueueQueueSessionDeltaEvent } from '../../lib/coalesceWorkspaceEvents';

function applyQueueSessionJoin(
  event: Telecom.QueueSessionJoinedEvent,
): void | Promise<void> {
  const queue = getQueue(event.queueId);

  log('rtcs:queue:session_join:' + queue?.name, event);

  if (!queue) {
    return refreshQueueOnCacheMiss(event.queueId);
  }

  if (
    featureFlagModule.isEnabled(FeatureFlagKeys.featureShowQueueLongestWaitTime)
  ) {
    queue.sessions = [
      ...(queue.sessions || []),
      {
        id: event.conversationId,
        position: event.joinedAtPosition,
        name: event.source.displayName ?? event.source.address,
        enteredAt: new Date(event.joinedAtTime),
      },
    ].sort((a, b) => a.enteredAt.getTime() - b.enteredAt.getTime());
  } else {
    queue.sessions = [
      ...(queue.sessions || []),
      {
        id: event.conversationId,
        position: event.joinedAtPosition,
        name: event.source.displayName ?? event.source.address,
        enteredAt: new Date(event.joinedAtTime),
      },
    ];
  }

  setQueueStatus(queue, event);
}

function handleQueueSessionJoin(event: Telecom.QueueSessionJoinedEvent) {
  return enqueueQueueSessionDeltaEvent(event.queueId, () =>
    applyQueueSessionJoin(event),
  );
}

export default handleQueueSessionJoin;
